import { useAppSelector } from '../hooks';
import { IDLC_1129_FLAG } from '../utils/featureFlagKeys';

// IDLC-1129 ships behind one per-user flag (`idlc-1129`). Each feature reads it through its own hook,
// so call sites say what they gate and the features can get separate flags later without touching them.

const useIdlc1129Flag = (): boolean => useAppSelector((s) => s.featureFlags.userFeatureFlags.includes(IDLC_1129_FLAG));

/** "Contact support" in the profile menu and cheat sheet, and the support link in the footer. */
export const useSupportContactEnabled = (): boolean => useIdlc1129Flag();

/** Choosing the photometries that go into the PDF export, and the export preview's loading states. */
export const usePdfPhotometrySelectionEnabled = (): boolean => useIdlc1129Flag();

/** The Pedestrian zone layer type in the type dropdowns and in name-based layer type detection. */
export const usePedestrianLayerTypeEnabled = (): boolean => useIdlc1129Flag();
